
import React from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash';

// import icon_download from "custom/flaveschoerghuber20/sug_icon-download.png"
// import icon_xls from "custom/flaveschoerghuber20/sug_icon-xls.png"
// import icon_jpg from "custom/flaveschoerghuber20/sug_icon-jpg.png"
// import icon_pdf from "custom/flaveschoerghuber20/sug_icon-pdf.png"

// function FileTypeIcon(extension) {
//   switch (extension) {
//     case 'xls':
//     case 'xlsx':
//       return icon_xls;
//     case 'jpg':
//     case 'jpeg':
//       return icon_jpg;
//     case 'pdf':
//       return icon_pdf;
//     default:
//       return icon_pdf;
//   }
// }

export default function Downloads() {
  
  const downloads = useSelector(state => state.events.find(event => event.id == state.videoRoom.active_event_id).files)
  const downloadLink = useSelector(state => state.downloadLink)
  console.log("downloads", downloads)

  return (
    <>
      {downloads.length == 0 ? (
        <i>Keine Downloads vorhanden</i>
      ) : (
        <>
          {_.map(downloads, (data, filekey) => {
            console.log("data", data)
            return (
            <div className="row mt-2" key={"filedownload" + filekey}>
              <div className="col">
                <a href={downloadLink + "?link=" + data.url + "&title=" + data.title} target="_blank" className="downloadlink">
                  <img src={icon_download} className="downloadimg mt-1 float-right"/>
                  <div className="downloadfileimg">
                    {/*<img src={FileTypeIcon(data.extension)}  className=""/>*/}
                  </div>
                  
                  {data.title}
                  <small className="d-none text-muted">{data.description}</small>
                </a>
              </div>
            </div>
            )
          })}
        </>
      )}
    </>
  )
}
